export default __webpack_public_path__ + "static/02-qs-world-mobile-43b19681ad92f376eb2fb66b21bf13ad.svg";